import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "react-bootstrap";

const CourseCard = ({ course }) => {
  console.log(course);
  
  // Parse tags
  const tags = course.tags
    ? course.tags.split(",").map((tag) => tag.trim())
    : [];

  // Determine Category and remaining tags
  const category = course.category || (tags.length > 0 ? tags[0] : "General");
  const displayTags = course.category ? tags : tags.slice(1);

  // Helper for difficulty colors
  const getDifficultyStyles = (level) => {
    switch (level) {
      case "Beginner":
        return { bg: "#e2f0d9", text: "#385723" };
      case "Intermediate":
        return { bg: "#fff2cc", text: "#7f6000" };
      case "Advanced":
      default:
        return { bg: "#fce4d6", text: "#c65911" };
    }
  };

  const diffStyle = getDifficultyStyles(course.difficulty_level);

  // Get provider initial
  const providerInitial = course.provider_name ? course.provider_name.charAt(0).toUpperCase() : "C";

  return (
    <div className="col-12 col-md-6 col-lg-6 mb-4 d-flex">
      <div 
        className="card w-100" 
        style={{
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.04)",
          border: "1px solid #eceff1",
          background: "#fff",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 12px 30px rgba(0, 0, 0, 0.08)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "none";
          e.currentTarget.style.boxShadow = "0 10px 25px rgba(0, 0, 0, 0.04)";
        }}
      >
        {/* Top Gradient Bar */}
        <div style={{ height: "6px", background: "linear-gradient(90deg, #7b2cbf 0%, #4cc9f0 100%)" }}></div>
        
        <div className="card-body p-4 d-flex flex-column h-100">
          
          {/* Top Badges Row */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            {/* Category */}
            <div 
              style={{
                display: "inline-flex",
                alignItems: "center",
                backgroundColor: "#f3e8ff",
                color: "#7e22ce",
                padding: "6px 14px",
                borderRadius: "50px",
                fontSize: "12px",
                fontWeight: "700",
                letterSpacing: "0.3px",
              }}
            >
              {/* <i className="fas fa-brain me-2" style={{ fontSize: "12px" }}></i> */}
              {category}
            </div>
            
            {/* Difficulty and Duration */}
            <div className="d-flex align-items-center gap-3">
              <span 
                style={{
                  backgroundColor: diffStyle.bg,
                  color: diffStyle.text,
                  padding: "5px 12px",
                  borderRadius: "8px",
                  fontSize: "12px",
                  fontWeight: "900",
                }}
              >
                {course.difficulty_level}
              </span>
              
              <div className="d-flex align-items-center text-muted" style={{ fontSize: "13px", fontWeight: "500" }}>
                <i className="far fa-clock me-2" style={{ fontSize: "14px" }}></i>
                {course.duration}
              </div>
            </div>
          </div>

          {/* Title */}
          <h3 
            className="mb-2" 
            style={{ 
              fontSize: "20px", 
              fontWeight: "700", 
              color: "#0f172a",
              lineHeight: "1.3" 
            }}
          >
            {course.course_title}
          </h3>

          {/* Description */}
          <p 
            style={{
              fontSize: "14px",
              color: "#475569",
              lineHeight: "1.5",
              minHeight: "63px",
              maxHeight: "63px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "3",
              WebkitBoxOrient: "vertical",
              
            }}
          >
            {course.description}
          </p>

          {/* Tags */}
          <div className="d-flex flex-wrap gap-2 mb-4" style={{ minHeight: "32px" }}>
            {displayTags.slice(0, 4).map((tag, index) => (
              <Badge className="me-2 mb-2" key={index}>{tag}</Badge>
            ))}
            {displayTags.length > 4 && (
             <Badge className="me-2 mb-2">
                +{displayTags.length - 4} more
              </Badge>
            )}
          </div>

          {/* Footer Row (Provider & Start Learning Button) */}
          <div className="d-flex justify-content-between align-items-center mt-auto">
            {/* Provider Box */}
            <div 
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #e2e8f0",
                borderRadius: "14px",
                padding: "8px 14px 8px 10px",
                backgroundColor: "#fafafb",
              }}
            >
              <div 
                style={{
                  width: "28px",
                  height: "28px",
                  backgroundColor: "#10b981",
                  borderRadius: "50%",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "700",
                  fontSize: "12px",
                  marginRight: "10px",
                  boxShadow: "0 2px 5px rgba(16, 185, 129, 0.2)",
                }}
              >
                {providerInitial}
              </div>
              <div className="d-flex flex-column">
                <span style={{ fontSize: "9px", fontWeight: "700", color: "#10b981", letterSpacing: "0.5px", lineHeight: "1" }}>
                  PROVIDER
                </span>
                <span style={{ fontSize: "13px", fontWeight: "700", color: "#1e293b", marginTop: "2px" }}>
                  {course.provider_name}
                </span>
              </div>
            </div>

            {/* Start Learning Button */}
            <Link 
              to={`/course-details/${course.id}`}
              className="btn text-white d-flex align-items-center"
              style={{
                backgroundColor: "#0f172a",
                borderRadius: "12px",
                padding: "10px 18px",
                fontSize: "13px",
                fontWeight: "700",
                boxShadow: "0 4px 10px rgba(15, 23, 42, 0.15)",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#1e293b";
                e.currentTarget.style.boxShadow = "0 6px 15px rgba(15, 23, 42, 0.25)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#0f172a";
                e.currentTarget.style.boxShadow = "0 4px 10px rgba(15, 23, 42, 0.15)";
              }}
            >
              <i className="fas fa-play me-2" style={{ fontSize: "10px" }}></i>
              Start Learning
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CourseCard;
